import { RouteComponentProps, withRouter } from 'react-router';
import { RetornoAcesso } from '../Modelos/ObjetosDiversos';
import { Roteador } from '../Servicos/Roteador';
import { Resposta, TrataResposta, ParametrosDiversos, AlteraTiposGeracao, RetornaDataAAAAMMDD, RetornaStringData, AlteraPadroesRecebimento, Iheaders, GeraHeader, GeraTrailler, GeraDetalhe, DataSql, formataDecimal, NumeroBanco, nulltoNumber } from '../Servicos/Utilidades';
import ApiService from '../Servicos/ApiService';
import { Recebimentos } from '../Modelos/Recebimentos';
import BarraLateral from '../Componentes/Barralateral';
import Toast from '../Componentes/Toast';
import Progresso from '../Componentes/Progresso';
import ProgressoEtiqueta from '../Componentes/ProgressoEtiqueta';
import { makeStyles, Theme, createStyles, Grid, Button, Typography, Box } from '@material-ui/core';
import React from 'react';
import SaveIcon from '@material-ui/icons/Save';
import PageviewIcon from '@material-ui/icons/Pageview';
import { Component } from 'react';
import Selecao from '../Componentes/Selecao';
import { Contas } from '../Modelos/Contas';
import { Clientes } from '../Modelos/Clientes';
import { Parametros } from '../Modelos/Parametros';
import { Redes } from '../Modelos/Redes';
import FileSaver from 'file-saver';
import TabelaBase from '../Componentes/TabelaBase';
import { Ocorrencias_Recebimento } from '../Modelos/Ocorrencias_Recebimento';
import { Pessoa_Documentos } from '../Modelos/Pessoa_Documentos';

const srv = new ApiService();

const useStyles = makeStyles((theme: Theme) => createStyles({
    griddados: {
      width: "100%",
      margin: "0 0 0 0"
    },
    gridtab: {
      width: "50%",
      margin: "0 0 0 0"
    },
    divgrid: {
        width: '90%',
        margin: '5% 7% 0'
    },
    divtabs: {
        width: '90%',
        margin: '0% 7% 0'
    },
    boxpanel: {
        width: '104%',
        margin: '0% 0% 0% -2%',
        padding: '0 0 0 0'
    },
    textoform: {
        margin: "0% 0%",
        width: "100%",
        background: 'white'
    },
    botao: {
        margin: '0 5% 0 5%',
        width: '40%'
      },
    tab: {
        minWidth: "50%",
        width: "50%"
    },
    gridcampos: {
        width: "80%",
        margin: "0 0 0 0"
    },
    gridfoto: {
        width: "20%",
        margin: "0 0 0 0"
    },
}));

let tabelarec: Tabrec[] = [];
let recret: {id_rcbt: number, idinterno_rcbt: string, vencto_rcbt: Date, valor_rcbt: number, id_cli: number, nome_pessoa: string, fantasia_pessoa: string, nome_rede: string, loja_cli: number}[] = [];
let selecionadas: number[] = [];
let remessa: string[] = [];
let arqrem: string = '';
let hoje=new Date();
let totreg = 0;
let interv = 0;
let indcta = -1;

type PrincipalProps=
{
    dadosobt: RetornoAcesso
    contas: Contas[];
    redes: Redes[];
    mensagem: (mensagem: string, severidade: string, duracao:number, retorna?:boolean) => void
}

type Tabrec=
{
    id: number,
    id_interno: string,
    vencto_rcbt: Date,
    valor_rcbt: number,
    id_cli: number,
    nome_pessoa: string,
    fantasia_pessoa: string,
    nome_rede: string,
    loja_cli: number,
    cliente: Clientes,
    flagedicao: string
}

const PrincipalGeracaoRemessas = ({dadosobt, contas, redes, mensagem }: PrincipalProps) =>
{
    const classes = useStyles();
    const [rede,setrede]=React.useState(0);
    const [conta,setconta]=React.useState(0);
    const [progresso,setaprogresso]=React.useState({processo: false, percentual: 0});
    const [cliproc,setcliproc]=React.useState('');
    const [operexec,setoperexec]=React.useState('A');

    const srv = new ApiService();

    const onChangeRecebimentoSelect = (event: React.ChangeEvent<{name?: string | undefined; value: unknown;}>, child: React.ReactNode, campo?: string | undefined) =>
    {
        if(campo && event.target.value)
        {
            let valor:number = 0;
            valor = typeof event.target.value === 'string' ? parseInt(event.target.value) : typeof event.target.value === 'number' ? event.target.value : 0; 
            if(campo==='id_cta')
            {
                setconta(valor)
            }
            else if(campo==='id_rede')
            {
                setrede(valor)
            }
        }
    }

    const AlteraSelecionadas = (sel: number[]) =>
    {
        selecionadas=sel;
    }

    const obtemLancamentos = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => 
    {
        srv.Get('Recebimentos/7,8' + (rede>0 ? ',9/' : '/') + conta.toString().trim()+',' + ParametrosDiversos.sitpadrao.toString().trim() + (rede>0 ? ','+rede.toString().trim()+'/' : '/') + conta.toString().trim()+',' + ParametrosDiversos.sitpadrao.toString().trim()+ (rede>0 ? ',' + rede.toString().trim() : '') + '/A/0', '', '', dadosobt.objac.token, false)
        .then((ddret: any) => 
        {
            let dadosret: Resposta = TrataResposta(ddret);
            if (dadosret.ok)
            {
                totreg = dadosret.retorno.length;
                if (totreg>0)
                {
                    recret=[];
                    dadosret.retorno.forEach((rc:any) => recret.push(rc));
                    tabelarec=[];
                    interv = Math.max(Math.ceil(totreg/100),1);
                    setaprogresso({processo:true, percentual: 0});
                    setoperexec('B');
                    IniciaPreenchimentoTabela();
                }
                else
                {
                    mensagem('Não há registros para os filtros informados','warning',5000, false);
                }
            }
            else
            {
                mensagem('Erro: Erro obtendo dados de recebimentos (' + dadosret.erro + ')','error',5000, false);
            }
        })
        .catch(Error => mensagem('Erro obtendo dados de recebimentos acessando a API (' + Error.name + ' - ' + Error.message + ')','error',5000, false));
    }

    const IniciaPreenchimentoTabela = () =>
    {
        PreencheTabela(0);
    }

    const PreencheTabela = (indrec: number) =>
    {
        if (indrec % interv===0 || indrec===totreg-1)
        {
            setaprogresso({processo: true, percentual: Math.trunc(((indrec+1)/totreg)*100)});
        }
        setcliproc(recret[indrec].id_rcbt.toString()+' - '+recret[indrec].idinterno_rcbt+' - '+recret[indrec].loja_cli.toString()+' - '+recret[indrec].fantasia_pessoa+' - '+RetornaStringData(recret[indrec].vencto_rcbt)+' - '+formataDecimal(recret[indrec].valor_rcbt.toString()));
        srv.Get('Clientes/'+(recret[indrec].id_cli.toString().trim()), '', '', dadosobt.objac.token, false)
        .then((ddret: any) => 
        {
            let dadosret: Resposta = TrataResposta(ddret);
            if (dadosret.ok)
            {
                tabelarec.push(
                {
                    id: recret[indrec].id_rcbt,
                    id_interno: recret[indrec].idinterno_rcbt,
                    vencto_rcbt: recret[indrec].vencto_rcbt,
                    valor_rcbt: recret[indrec].valor_rcbt,
                    id_cli: recret[indrec].id_cli,
                    nome_pessoa: recret[indrec].nome_pessoa,
                    fantasia_pessoa: recret[indrec].fantasia_pessoa,
                    nome_rede: recret[indrec].nome_rede,
                    loja_cli: recret[indrec].loja_cli,
                    cliente: dadosret.retorno,
                    flagedicao: ''
                
                });
                ChamaProximaTabela(indrec+1);
            }
            else
            {
                setoperexec('A');
                mensagem('Erro obtendo dados de clientes (' + dadosret.erro + ')','error',5000, false);
            }
        })
        .catch(Error => {setoperexec('A'); mensagem('Erro obtendo dados de clientes acessando a API (' + Error.name + ' - ' + Error.message + ')','error',5000, false)});
    }

    const ChamaProximaTabela = (indrec: number) =>
    {
        if (indrec<recret.length)
        {
            PreencheTabela(indrec);
        }
        else
        {
            setoperexec('C');
            setcliproc('');
            setaprogresso({processo: false, percentual:0});
        }
    }

    const IniciaGravacao = () =>
    {
        if (selecionadas.length>0 && tabelarec.length>0)
        {
            indcta=contas.findIndex(cta => cta.id_cta===conta);
            if (indcta>=0)
            {
                hoje=new Date();
                setoperexec('D');
                setaprogresso({processo: true, percentual:0});
                remessa=[];
                arqrem=(contas[indcta].banco_cta==='237' ? 'CB' : 'RM')+(hoje.getDate().toString().padStart(2,'0'))+((hoje.getMonth()+1).toString().padStart(2,'0'))+'01';
                remessa.push(GeraHeader(parseInt(contas[indcta].banco_cta), contas[indcta].identcob_cta, contas[indcta].nome_cta, contas[indcta].seqrem_cta))
                ObtemCliente(0);
            }
            else
            {
                mensagem('Conta não encontrada (' + conta.toString().trim()+ ')','error',5000,false);
            }
        }
        else
        {
            mensagem('Nenhum registro selecionado para geração de recebimentos','warning',5000, false)
        }
    }

    const ObtemCliente = (indrec: number) =>
    {
        setcliproc((indrec+1).toString()+'/'+totreg.toString()+' - '+tabelarec[indrec].id_cli.toString()+' - '+RetornaStringData(tabelarec[indrec].vencto_rcbt)+' - '+formataDecimal(tabelarec[indrec].valor_rcbt.toString()));
        if (indrec % interv===0 || indrec===totreg-1)
        {
            setaprogresso({processo: true, percentual: Math.trunc(((indrec+1)/totreg)*100)});
        }
        if (selecionadas.some(sel => sel===tabelarec[indrec].id))
        {
            let cliente: Clientes = tabelarec[indrec].cliente;
            let achadoc: number = cliente.pessoa.documentos.findIndex((dct: Pessoa_Documentos) => dct.id_doc===1 || dct.id_doc===2);
            let cliobt: {id_cli: number, cpfcnpj: string, id_pessoa: number, nome_pessoa: string, fantasia_pessoa: string, id_rede: number, nome_rede: string, loja_cli: number, enderecos: {id_enps: number, id_tpen: number, padrao_enps: string, id_end: number, cep_end: string, logr_end: string, numero_end: string, compl_end: string, bairro_end: string, id_cid: number, nome_cid: string, codibge_cid: string, id_uf: number, sigla_uf: string, nome_uf: string, codibge_uf: string}[]} = 
            {
                id_cli: cliente.id_cli,
                cpfcnpj: (achadoc>=0 ? cliente.pessoa.documentos[achadoc].valor_psdc : ''),
                id_pessoa: cliente.pessoa.id_pessoa,
                nome_pessoa: cliente.pessoa.nome_pessoa,
                fantasia_pessoa: cliente.pessoa.fantasia_pessoa,
                id_rede: cliente.id_rede,
                nome_rede: '',
                loja_cli: cliente.loja_cli,
                enderecos: [],
            }
            cliente.pessoa.enderecos.forEach(end => 
                cliobt.enderecos.push(
                    {
                        id_enps: end.id_enps,
                        id_tpen: end.id_tpen,
                        padrao_enps: end.padrao_enps,
                        id_end: end.endereco.id_end,
                        cep_end: end.endereco.cep_end,
                        logr_end: end.endereco.logr_end,
                        numero_end: end.numero_end,
                        compl_end: end.compl_end,
                        bairro_end: end.endereco.bairro_end,
                        id_cid: end.endereco.cidade.id_cid,
                        nome_cid: end.endereco.cidade.nome_cid,
                        codibge_cid: end.endereco.cidade.codibge_cid,
                        id_uf: end.endereco.cidade.uf.id_uf,
                        sigla_uf:end.endereco.cidade.uf.sigla_uf,
                        nome_uf:end.endereco.cidade.uf.nome_uf,
                        codibge_uf:end.endereco.cidade.uf.codibge_uf
                    }
                ))

            GravaRecebimento(indrec, cliobt);
        }
        else
        {
            ChamaProximo(indrec);
        }
    }

    const GravaRecebimento = (indrec: number, cliobt: {id_cli: number, cpfcnpj: string, id_pessoa: number, nome_pessoa: string, fantasia_pessoa: string, id_rede: number, nome_rede: string, loja_cli: number, enderecos: {id_enps: number, id_tpen: number, padrao_enps: string, id_end: number, cep_end: string, logr_end: string, numero_end: string, compl_end: string, bairro_end: string, id_cid: number, nome_cid: string, codibge_cid: string, id_uf: number, sigla_uf: string, nome_uf: string, codibge_uf: string}[]} ) =>
    {
        srv.Get('Recebimentos/'+(tabelarec[indrec].id.toString().trim()), '', '', dadosobt.objac.token, false)
        .then((ddret: any) => 
        {
            let dadosret: Resposta = TrataResposta(ddret);
            if (dadosret.ok)
            {
                let recebimento: Recebimentos = dadosret.retorno; 
                if (!recebimento.numban_rcbt || recebimento.numban_rcbt.trim().length<1)
                {
                    recebimento.carteira_rcbt=contas[indcta].carteira_cta
                    recebimento.numban_rcbt=NumeroBanco(nulltoNumber(parseInt(contas[indcta].banco_cta)),contas[indcta].agencia_cta,contas[indcta].conta_cta,contas[indcta].carteira_cta,recebimento.idinterno_rcbt);
                }
                remessa.push(GeraDetalhe(parseInt(contas[indcta].banco_cta),contas[indcta].identben_cta,recebimento,cliobt,remessa.length+1));
                let ocor=new Ocorrencias_Recebimento()
                ocor.id_tpor=ParametrosDiversos.idremessa;
                ocor.id_rcbt=tabelarec[indrec].id;
                ocor.data_ocrc=DataSql(hoje);
                ocor.id_oper=dadosobt.objac.id_oper;
                ocor.nomearq_ocrc=arqrem;
                ocor.tipoarq_ocrc='1';
                ocor.regbanco_ocrc=remessa.length;
                ocor.ocorbanco_ocrc='01';
                recebimento.ocorrencias.push(ocor);
                recebimento.id_strc=ParametrosDiversos.sitremessa;
                recebimento.id_oper=dadosobt.objac.id_oper;
                srv.Post('Recebimentos/','',JSON.stringify(recebimento),dadosobt.objac.token,false)
                .then((ddret: any) => 
                {
                    let dadosret: Resposta = TrataResposta(ddret);
                    if (!dadosret.ok)
                    {
                        mensagem('Erro gravando recebimento (' + dadosret.erro + ')','error',6000);
                        setoperexec('A');
                    }
                    else
                    {
                        ChamaProximo(indrec);
                    }
                })
                .catch(Error => { mensagem('Erro gravando recebimento acessando a API (' + Error.name + ' - ' + Error.message + ')', 'error',6000); setoperexec('A'); });
            }
            else
            {
                mensagem('Erro obtendo dados de recebimento (' + dadosret.erro + ')','error',6000);
                setoperexec('A');
            }
        })
        .catch(Error => { mensagem('Erro obtendo dados de recebimento acessando a API (' + Error.name + ' - ' + Error.message + ')','error',5000, false); setoperexec('A');});
    }

    const ChamaProximo = (indrec: number) =>
    {
        if (tabelarec.length>(indrec+1))
        {
            ObtemCliente(indrec+1);
        }
        else
        {
            srv.Put('Contas/','',JSON.stringify({id_cta: contas[indcta].id_cta, seqrem_cta: (contas[indcta].seqrem_cta ? contas[indcta].seqrem_cta as number :  0)+1}),dadosobt.objac.token,false)
            .then((ddret: any) => {
                console.log('Erro ddret: ', ddret)
                let dadosret: Resposta = TrataResposta(ddret);
                if (!dadosret.ok)
                {
                    mensagem('Erro gravando sequencia de remessa (' + dadosret.erro + ')','error',6000);
                    setoperexec('A');
                }
                else
                {
                    remessa.push(GeraTrailler(parseInt(contas[indcta].banco_cta),remessa.length+1))
                    downloadarquivo();
                    mensagem('Final de processamento\nSequencia de remessa atualizada','info',10000,true);
                }
            }).catch(Error => { mensagem('Erro acessando a API - atualizando sequencia de remessa (' + Error.name + ' - ' + Error.message + ')', 'error',6000); setoperexec('A');});
        }
    }

    const hdtabrec: Iheaders[] = 

    [
        { titulo: 'Id', alinhamento:'right', coluna: 'id', mascara: ''},
        { titulo: 'Id interno', alinhamento: 'left', coluna: 'id_interno', mascara: '' },
        { titulo: 'Vencimento', alinhamento: 'center', coluna: 'vencto_rcbt', mascara: 'data' },
        { titulo: 'Valor', alinhamento: 'right', coluna: 'valor_rcbt', mascara: 'decimal' },
        { titulo: 'Id cliente', alinhamento: 'right', coluna: 'id_cli', mascara: '' }, 
        { titulo: 'Cliente', alinhamento: 'left', coluna: 'nome_pessoa', mascara: '' }, 
        { titulo: 'Fantasia', alinhamento: 'left', coluna: 'fantasia_pessoa', mascara: '' }, 
        { titulo: 'Rede', alinhamento: 'left', coluna: 'nome_rede', mascara: '' },
        { titulo: 'Loja', alinhamento: 'right', coluna: 'loja_cli', mascara: '' }, 
        { titulo: '#', alinhamento: 'right', coluna: 'flagedicao', mascara: '' }
    ]
 
    const downloadarquivo = () =>
    {
        var blob = new Blob(remessa, {type: "text/plain;charset=utf-8"});
        FileSaver.saveAs(blob,arqrem);        
    }
  
    return (
        <div>
            <div className={classes.divgrid}>
                <Grid container spacing={1} className={classes.griddados}>
                    <Grid item xs={4}>
                        <Selecao valor={rede}  nome='id_rede' label='Rede' required={false} habilitado={true} onchange={onChangeRecebimentoSelect} conteudo={redes} nulo={[0,'Todas']} classe={classes.textoform} />
                    </Grid>
                    <Grid item xs={4}>
                        <Selecao valor={conta}  nome='id_cta' label='Conta' required={false} habilitado={true} onchange={onChangeRecebimentoSelect} conteudo={contas} nulo={[0,'Indefinida']} classe={classes.textoform} />
                    </Grid>
                    <Grid item xs={4}>
                        <Button variant="contained" color="primary" disabled={'AC'.indexOf(operexec)===-1 || !conta || conta===0} className={classes.botao} onClick={(event) => obtemLancamentos(event)} endIcon={<PageviewIcon/>}>Obtem Lançamentos</Button>
                        <Button variant="contained" color="primary" disabled={operexec!=='C'} className={classes.botao} onClick={IniciaGravacao} endIcon={<SaveIcon/>}>Gera Remessa</Button>
                    </Grid>
                    {progresso.processo ?
                        <Grid container spacing={1}>
                            <Grid item xs={4}>
                                <Box minWidth={35} margin='20px 0 0 10px'>
                                    <Typography color='primary'>{operexec==='B' ? 'Obtendo recebimentos' : operexec==='D' ? 'Gravando arquivo remessa' : ''}</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={4}>
                                <Box minWidth={35} margin='20px 0 0 10px'>
                                    <Typography noWrap={true} color='primary'>{cliproc}</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={4}>
                                <ProgressoEtiqueta value={progresso.percentual} tipo='B' />
                            </Grid>
                        </Grid>
                        :
                        null
                    }
                    <Grid item xs={12}>
                        <TabelaBase linhasoriginais={'CD'.indexOf(operexec)!==-1 ? tabelarec : []} cab={hdtabrec} selecao={true} edicao={false} adicao={false} habfiltro={false} onClickEdicao={(val1, val2) => {}} titulo={'Recebimentos'} full={true} linhasiniciais={15} exclusao={false} auxedit={1} auxexclui={2} onSelect={AlteraSelecionadas} />
                    </Grid>
                </Grid>
            </div>
        </div>
    )
}  

type PathParamsType =
{

}

type PropsType = RouteComponentProps<PathParamsType>;

interface IState {
  dadoobtido: boolean,
  openToast: boolean,
  severidadeToast: string,
  mensagemToast: string,
  duracaoToast: number,
  acessosok: boolean,
}

class GeracaoRemessas extends Component<PropsType, IState>
{
    private _dadosobt: RetornoAcesso;
    private _roteador: Roteador;
    private _dadoobtido: boolean;
    private _acessos: number;
    private _contas: Contas[];
    private _redes: Redes[];
    private _parametros: Parametros[];
    private _retornamensagem: boolean;
    
    constructor(props: any)
    {
        super(props);

        this._dadosobt=new RetornoAcesso();

        if (props.location.state)
        {
            if(props.location.state.dadosret)
            {
                this._dadosobt=props.location.state.dadosret;
            }
        }

        if (!this._dadosobt.ok)
        {
            this.props.history.push({pathname: '/'})
        }

        this._roteador=new Roteador(this._dadosobt, '/GeracaoRemessas');
        this._roteador.history=props.history;
        this._dadoobtido=false;
        this._contas = [];
        this._redes = [];
        this._parametros = [];
        this._retornamensagem=false;
    
        this._acessos=0;
    
        if (this._dadosobt.ok)
        {
            this._dadoobtido=true;
        }
            this.state =
            {
                dadoobtido: this._dadoobtido,
                openToast: false,
                severidadeToast: 'success',
                mensagemToast: '',
                duracaoToast: 6000,
                acessosok: false,
            }
        if (this._dadosobt.ok)
        {
            this.ObtemDados('Contas/','contas',this.setacontas.bind(this));
            this.ObtemDados('Redes/','redes',this.setaredes.bind(this));
            this.ObtemDados('Parametros/','parâmetros',this.setaparametros.bind(this));
        }
    }
    
    setacontas(registros: any) {this._contas=registros; this.aumentaAcessos();};
    setaredes(registros: any) {this._redes=registros; this.aumentaAcessos();};
    setaparametros(parobt: Parametros[]) {this._parametros = parobt; this.aumentaAcessos();};

    aumentaAcessos()
    {
        this._acessos = this._acessos+1
        if(this._acessos>2)
        {
            AlteraTiposGeracao(this._parametros);
            AlteraPadroesRecebimento(this._parametros);
            this.setState({acessosok: true});
        }
    }
        
    ObtemDados(caminho: string, msgerr: string, obret: (registros: any) => void)
    {
        srv.Get(caminho, '', '', this._dadosobt.objac.token, false)
        .then((ddret: any) => 
        {
        let dadosret:Resposta = TrataResposta(ddret);
        if(dadosret.ok)
        {
            obret(dadosret.retorno)
        }
        else
        {
            this.setState( {openToast: true, severidadeToast: 'error', duracaoToast: 6000, mensagemToast: 'Erro obtendo ' + msgerr + ' (' + dadosret.erro + ')' }); 
            this.aumentaAcessos();
        }
        })
        .catch(Error => {this.setState( {openToast: true, severidadeToast: 'error', duracaoToast: 6000, mensagemToast: 'Erro acessando a API - obtendo ' + msgerr + ' (' + Error.name + ' - ' + Error.message + ')' }); this.aumentaAcessos();});
    }

    ExibeMensagem(mensagem: string, severidade: string, duracao:number, retorna:boolean=false)
    {
        this.setState({openToast: true, severidadeToast: severidade, mensagemToast: mensagem, duracaoToast: duracao})
        this._retornamensagem=retorna;
    }

    FechaMensagem()
    {
        this.setState({openToast: false});
        if (this._retornamensagem)
        {
          this._roteador.rota(0,0);
        }
    }

    render()
    {
        if (!this._dadosobt.ok)
        {
            return null
        }
        else
        {
            return (
            <div className="Home">
                <header className="Home-header">
                    <BarraLateral dadosacesso={this._dadosobt} botaoclick={this._roteador.rota.bind(this._roteador)} clasrot={this._roteador} recurso='Geração de Remessa'/>
                </header>
                <main>
                { this.state.acessosok ?
                    <PrincipalGeracaoRemessas dadosobt={this._dadosobt} contas={this._contas} redes={this._redes} mensagem={this.ExibeMensagem.bind(this)}/>
                    :
                    <Progresso/>
                }
                </main>
                <Toast open = {this.state.openToast} handleClose = {this.FechaMensagem.bind(this)} severity = { this.state.severidadeToast} duracao= {this.state.duracaoToast}>{this.state.mensagemToast}</Toast>
            </div>
            )
        }
    }
}

export default withRouter(GeracaoRemessas);
